import { useCallback, useState } from 'react';

export interface UseFreCompletedThisSessionResult {
  readonly freCompletedThisSession: boolean;
  readonly markFreCompleted: () => void;
}

export const useFreCompletedThisSession = (): UseFreCompletedThisSessionResult => {
  const [freCompletedThisSession, setFreCompletedThisSession] = useState(false);
  const markFreCompleted = useCallback(() => {
    setFreCompletedThisSession(true);
  }, []);

  return { freCompletedThisSession, markFreCompleted };
};
